export default __webpack_public_path__ + "static/img3@2x-d8e1eeca777dee2c7d199eb74a861880.jpg";